import axios from 'axios';

class tenantService {
  constructor() {
    this.API_URL = process.env.REACT_APP_API_URL_V;
    this.apiClient = axios.create({
      baseURL: this.API_URL,
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    });

    this.apiClient.interceptors.request.use(config => {
      //   const token = JSON.parse(localStorage.getItem('loginInfonetApp'))?.token || '';
      //   console.log(token)
      const token = localStorage.getItem("accesstoken");
      config.headers['x-auth-token'] = token;
      return config;
    }, error => {
      return Promise.reject(error);
    });
  }

  async gettenants(data) {
    const response = await this.apiClient.post('/acl/list', data);
    return response.data.data;
  }

  async addtenant(acl) {
    const response = await this.apiClient.post('/tenantcreate', acl);
    return response.data.data;
  }

  async updatetenant(id, acl) {
    const response = await this.apiClient.put(`/tenantupdate/${id}`, acl);
    return response.data;
  }

  async deletetenant(id) {
    const response = await this.apiClient.delete(`/tenantdelete/${id}`);
    return response.data;
  }

  async clientCreate(data) {
    const response = await this.apiClient.post('/clientcreate', data);
    return response.data;
  }

  async clientUpdate(id, acl) {
    const response = await this.apiClient.put(`/clientupdate/${id}`, acl);
    return response.data;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new tenantService();
